import { render, staticRenderFns } from "./indexOld.vue?vue&type=template&id=8b808a6c&scoped=true&"
import script from "./indexOld.vue?vue&type=script&lang=js&"
export * from "./indexOld.vue?vue&type=script&lang=js&"
import style0 from "./indexOld.vue?vue&type=style&index=0&id=8b808a6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b808a6c",
  null
  
)

export default component.exports